import React, { useContext, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import LogoutIcon from "@mui/icons-material/Logout";
// import Brightness4Icon from "@mui/icons-material/Brightness4";
// import Brightness7Icon from "@mui/icons-material/Brightness7";
import { AuthContext } from "../contexts/AuthContext";
import { ColorModeContext } from "../contexts/ThemeContext";
import { useNavigate } from "react-router-dom";
import { getWhatsAppSignupLink } from "../api/axios";

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const handleOnboarding = async () => {
  setLoading(true);
  try {
    console.log("[Navbar] Requesting WhatsApp signup link...");
    const response = await getWhatsAppSignupLink();
    console.log("[Navbar] API response:", response.data);

    const url = response.data.signupUrl || response.data.url;
    if (url) {
      console.log("[Navbar] Opening signup URL:", url);
      window.open(url, "_blank");
    } else {
      alert("Signup link not received.");
    }
  } catch (error) {
    console.error("[Navbar] Error generating signup link:", error);
    alert("Something went wrong.");
  } finally {
    setLoading(false);
  }
};


  return (
    <AppBar
      position="fixed"
      elevation={1}
      color="primary"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          WhatsApp Tool
        </Typography>

        {/* Onboarding Facebook Button */}
        <Tooltip title="Connect WhatsApp Business via Facebook">
          <span>
            <IconButton
              color="inherit"
              onClick={handleOnboarding}
              disabled={loading || !user}
              sx={{
                bgcolor: "#4267B2",
                color: "white",
                "&:hover": {
                  bgcolor: "#365899",
                },
                mx: 1,
              }}
            >
              {loading ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                <FacebookIcon />
              )}
            </IconButton>
          </span>
        </Tooltip>

        {/* Profile */}
        {user && (
          <>
            <Tooltip title="Account">
              <IconButton onClick={handleMenuOpen} size="small" sx={{ ml: 1 }}>
                <Avatar sx={{ bgcolor: deepPurple[500] }}>
                  {getInitials(user.name)}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              PaperProps={{ sx: { mt: 1.5, minWidth: 180 } }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
            >
              <MenuItem disabled>{user.name}</MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                Logout
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
